import { Alert } from "@generalapplications/ui";

export type ContactStatusNoticeProps = {
  status: "success" | "error";
  message: string;
};

/** What became of a submitted message: sent, or why it was not. */
export function ContactStatusNotice({
  status,
  message,
}: ContactStatusNoticeProps) {
  return status === "success" ? (
    <Alert tone="success" role="status">
      {message}
    </Alert>
  ) : (
    <Alert tone="danger" role="alert">
      {message}
    </Alert>
  );
}
